export const STATUS_OK = 'ok'
export const STATUS_WARNING = 'warning'
export const STATUS_ALERT = 'alert'
export const STATUS_NOT_AVAILABLE = 'not-available'

export type DeviceStatus =
    | typeof STATUS_OK
    | typeof STATUS_WARNING
    | typeof STATUS_ALERT
    | typeof STATUS_NOT_AVAILABLE
